console.log("[DEBUG...]: main.js loading");

removeYouTubeVideos = () => {
	const ytEmbeds = document.querySelectorAll(".sv-block-gdpr-youtube-embed");
	if (ytEmbeds.length > 0) {
		ytEmbeds.forEach((yt) => {
			yt.childNodes[0].style.display = "block";
			const iframe = yt.getElementsByTagName("iframe")[0];
			iframe.src = "";
			addCSSclasses(iframe, "has-light-grey-background-color");
		});
	}
	location.reload();
};

enableYouTubeVideos = () => {
	const ytEmbeds = document.querySelectorAll(".sv-block-gdpr-youtube-embed");
	if (ytEmbeds.length > 0) {
		ytEmbeds.forEach((yt) => {
			let dataSrc = yt.childNodes[0].dataset;
			let url = dataSrc.src;
			const iframe = yt.getElementsByTagName("iframe")[0];
			iframe.src = url;
			removeCSSclasses(iframe, "has-light-grey-background-color");
		});
	}
};

findAncestor = (el, cls) => {
	var element;
	do {
		el = el.parentNode;
		element = el.classList;
	} while (!element.contains(cls));
	return el;
	// console.log(el);
};

document.addEventListener("readystatechange", (e) => {
	if (document.readyState === "complete") {
		const addCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.add(cl));
		const removeCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.remove(cl));
		const hasCSSclasses = (el, ...cls) =>
			cls.map((cl) => el.classList.contains(cl));

		const getDeviceSize = () => {
			if (window.outerWidth >= 1023) {
				return "large";
			}

			if (window.outerWidth >= 640 && window.outerWidth <= 1023) {
				return "medium";
			}

			if (window.outerWidth < 640) {
				return "small";
			}
		};

		/**
		 *  Hamburger & navigation toggle
		 */
		const header = document.querySelector(".site-header");
		const nav = document.querySelector("#mainNavigation");
		const hamburger = document.getElementById("hamburger");
		const body = document.body;

		const openNavigation = () => {
			addCSSclasses(body, "overflow-hidden");
			addCSSclasses(hamburger, "is-active");
			hamburger.setAttribute("aria-expanded", true);
			addCSSclasses(nav, "is-active");
		};
		const closeNavigation = () => {
			removeCSSclasses(body, "overflow-hidden");
			removeCSSclasses(hamburger, "is-active");
			hamburger.setAttribute("aria-expanded", false);
			removeCSSclasses(nav, "is-active");
		};
		const toggleMainMenu = (e) => {
			const isActive = hamburger.getAttribute("aria-expanded");

			if ("false" == isActive) {
				openNavigation();
			} else {
				closeNavigation();
			}
		};
		hamburger.addEventListener("click", (e) => toggleMainMenu(e));

		/**
		 * Sub-menus
		 */
		const subMenus = nav.querySelectorAll(".menu-item-has-children");
		const openSubMenu = (e, subMenu) => {
			if (getDeviceSize() !== "large") {
				e.preventDefault();
			}
			const ul = subMenu.querySelector("ul");

			if (hasCSSclasses(ul, "active")[0]) {
				removeCSSclasses(e.target, "active");
				removeCSSclasses(ul, "active");
			} else {
				addCSSclasses(e.target, "active");
				addCSSclasses(ul, "active");
			}
		};

		subMenus.forEach((subMenu) => {
			const anchor = subMenu.childNodes[0];
			const addListener = (e) => openSubMenu(e, subMenu);
			anchor.addEventListener("click", addListener);
		});

		/**
		 *  Share button events
		 */
		const capture = document.querySelectorAll("[data-event]");
		if (capture.length > 0) {
			const copyToClipboard = (node, content) => {
				navigator.clipboard
					.writeText(content)
					.then(
						() => {
							/* clipboard successfully set */
							console.log(
								`Copied text: "${content}" successfully`
							);
							addCSSclasses(node, "success");

							setTimeout(() => {
								removeCSSclasses(node, "success");
							}, 1500);
						},
						() => {
							/* clipboard write failed */
							console.log(`Copy text: "${content}" failed`);
						}
					)
					.catch((response) => {
						console.log("Error responseponse:", response);
					});
			};

			const cancelClicks = (capture) => {
				capture.forEach((node) => {
					// console.log("node", node);

					let eventValue = node.dataset.event;
					if ("copy" == eventValue) {
						let link = node.querySelector(".single__widget-link");

						link.addEventListener("click", (e) => {
							e.preventDefault();
							copyToClipboard(link, link.dataset.url);
						});

						link.addEventListener("keydown", (e) => {
							e.preventDefault();
							if (e.code != "Enter") return;

							copyToClipboard(link, link.dataset.url);
						});
					}
				});
			};

			cancelClicks(capture);
		}

		/**
		 *
		 */
		const sticky = document.querySelectorAll("[data-sticky]");
		let fixStickyItem;
		const stickySidebar = () => {
			const sticky = document.querySelectorAll("[data-sticky]");
			addCSSclasses(sticky[0], "is-fixed");

			const stickyContainer = document.querySelector("[data-container]");
			const stickyItem = sticky[0].getBoundingClientRect();

			fixStickyItem = (e) => {
				let scroll = window.pageYOffset;
				let containerOffsetTop = stickyContainer.offsetTop;
				let containerHeight = stickyContainer.offsetHeight;

				let stopBase =
					containerOffsetTop +
					containerHeight -
					stickyItem.height -
					30;
				// console.log("scroll", scroll);
				// console.log("stopBase", stopBase);

				const maxTop = containerOffsetTop;
				let didScroll = false;

				if (scroll >= maxTop && scroll <= stopBase) {
					didScroll = true;
				} else {
					didScroll = false;
				}

				if (didScroll) {
					sticky[0].style.top = `${scroll - maxTop + 39}px`;
				}
			};

			window.addEventListener("scroll", fixStickyItem);
		};

		const undoStickySidebar = (sticky) => {
			if (!fixStickyItem) return null;
			removeCSSclasses(sticky, "is-fixed");

			window.removeEventListener("scroll", fixStickyItem);
			fixStickyItem = false;
		};
		if (sticky.length > 0) {
			if (getDeviceSize() === "large") {
				if (sticky.length > 0) {
					stickySidebar();
				}
			}
		}

		/**
		 * Hide that pesky adminbar
		 */
		const admin = document.querySelector(".admin-bar");
		const adminBar = document.querySelector("#wpadminbar");
		if (admin && adminBar) {
			addCSSclasses(adminBar, "up");

			window.onmousemove = (e) => {
				// height from the top in px that we want to open the admin bar if we enter the area
				const openBarRegion = 30;
				if (e.clientY <= openBarRegion) {
					removeCSSclasses(adminBar, "up");
				} else {
					if (!adminBar.classList.contains("up")) {
						addCSSclasses(adminBar, "up");
					}
				}
				// console.log("e", e);
			};
		}

		/**
		 * Set-up our resize listener to check for device sizes
		 */
		window.onresize = (e) => {
			console.log("getDeviceSize()", getDeviceSize());

			if (getDeviceSize() !== "large") {
				if (sticky.length > 0) {
					undoStickySidebar(sticky[0]);
				}
			} else {
				if (sticky.length > 0) {
					stickySidebar();
				}
			}
		};

		/**
		 *
		 *
		 */
		const toggler = document.querySelectorAll("[data-toggler");
		if (toggler && toggler.length > 0) {
			toggler.forEach((btn) => {
				const expandShrinkToggleBox = (btn) => {
					const toggle = btn.nextElementSibling;
					const isOpen = hasCSSclasses(toggle, "is-open");
					// console.log("isOpen", isOpen);

					if (false === isOpen[0]) {
						addCSSclasses(btn, "is-open");
						addCSSclasses(toggle, "is-open");
					} else {
						removeCSSclasses(btn, "is-open");
						removeCSSclasses(toggle, "is-open");
					}
				};

				btn.addEventListener("click", (e) =>
					expandShrinkToggleBox(e.target)
				);
			});
		}

		/**
		 *
		 */
		// document.getElementById("cat").onchange = function () {
		// 	if (this.value !== "-1") {
		// 		var paramsString = "?cat=0";
		// 		console.log("paramsString", paramsString);

		// 		var searchParams = new URLSearchParams(paramsString);
		// 		console.log("searchParams", searchParams);
		// 		console.log("this.value", this.value);

		// 		searchParams.set("cat", this.value);
		// 		console.log("searchParams", searchParams);

		// 		// window.location = `${window.location.searchParams}`;
		// 	}
		// };
	}
	// Code above this brace
});
